

















import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import { UCIcon } from '@shared/ui';

import AMXButton from '~/components/AMXButton.vue';
import AMXFormField from '~/components/AMXFormField.vue';

interface YearSelectorFormEmitProps {
  emit: {
    (event: 'submit', selectedYear: string): void;
  };
}

export default defineComponent({
  components: {
    AMXButton,
    AMXFormField,
    UCIcon,
  },
  props: {
    validationError: {
      type: String,
      default: null,
    },
    vehicleYears: {
      type: Array as PropType<string[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(_: unknown, { emit }: YearSelectorFormEmitProps) {
    const selectedYear = ref('');

    const handleSelect = (e: Event) => {
      selectedYear.value = (e.target as HTMLSelectElement).value;
    };

    const handleSubmit = () => {
      emit('submit', selectedYear.value);
    };

    return {
      selectedYear,
      handleSelect,
      handleSubmit,
    };
  },
});
